import React, { useEffect, useState } from 'react'
import { EMPTY_OBJECT } from '../../constants/globalConstants'
import PropTypes from 'prop-types'
import { noop } from 'jquery'
import { messageExtendSuccessPayment, messageSuccessPayment } from '../../utils/helper'
import { errorMessage } from '../../constants/errorMessage'
import { Circles } from 'react-loader-spinner'
import { addEventLog } from '../../redux/actions/EventsLog'
import CONSTANTS from '../../redux/constants'
import { connect } from 'react-redux'
import NoData from '../NoData'
import GooglePayButton from '@google-pay/button-react'

const mobileGooglePayHL = (props) => {
    const {dispatch, notify, setThankYouMessage, setResponse, data, page, setPage, setDisplayError, setErrorMessage, displayError, failedMessage} = props

    const [ispaymentLoading, setIsPaymentLoading] = useState(false)
    

    useEffect(() => {
        setPage(0)
    },[])

    const paymentDataResponse = (paymentResponse) => {
        setIsPaymentLoading(true)
        console.log(paymentResponse)
        const responseToSubmit = data
        const request = JSON.parse(responseToSubmit?.request)
        request.walletPay = paymentResponse?.paymentMethodData?.tokenizationData?.token
        responseToSubmit.request = request
        submitResponseOnServer(responseToSubmit)
    }

    
    const submitResponseOnServer = (responseData) => {
        var headers = {}
        headers['Content-Type'] = 'application/json'
        headers['Authorization'] = responseData?.Authorization
        headers['X-ClientSecret'] = responseData?.['X-ClientSecret']
        headers['User-Agent'] = 'AwesomePOS/1.2.3'

        const request = responseData?.request
        setIsPaymentLoading(true)
        // document.getElementById('payload').innerHTML = 'Please wait...'     
        request.paymentMethods = 'GPAY'
        if(responseData?.api_url.includes('extend')){
          request['pave-make-extend-payment'] = 1
        }else{
          request['pave-make-web-ungated-checkin-payment'] = 1
        }
        
        
        fetch(responseData?.api_url, {
            method: 'POST',
            body: JSON.stringify(request),
            headers: headers,
        }).then(function (payApiResponse) {
            
            payApiResponse.json().then(function (json) {
                setIsPaymentLoading(false)
                const apiResponse = json
                
                setResponse(apiResponse)
                if(apiResponse?.errors && apiResponse?.errors?.message){
                    let errObject = {
                        payload: request,
                        errorMessage: apiResponse,
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.POST_CARD_PAYMENT_FAILURE} ${responseData?.api_url} response json parse`))
                    setErrorMessage(apiResponse?.errors?.message ? apiResponse?.errors?.message : errorMessage?.somethingWentWrong)
                    setPage(2)
                }else{
                    setDisplayError(true)
                    let errObject = {
                        payload: request,
                        errorMessage: apiResponse,
                    }
                    dispatch(addEventLog(errObject, `${CONSTANTS?.POST_CARD_PAYMENT_SUCCESS} ${responseData?.api_url} response json parse`))
                    if(responseData?.api_url.includes('extend')){
                        setThankYouMessage(messageExtendSuccessPayment)
                    }else{
                        setThankYouMessage(messageSuccessPayment)
                    }
                    setErrorMessage('')
                    setPage(1)
                }
            }).catch((err) => {
                setDisplayError(true)
                setIsPaymentLoading(false)
                setPage(2)
                setResponse(err)
                let errObject = {
                    payload: request,
                    errorMessage: err,
                }
                setErrorMessage(err ? err : errorMessage?.somethingWentWrong)
                notify('error', err ? err : errorMessage?.somethingWentWrong)

                dispatch(addEventLog(errObject, `${CONSTANTS?.POST_CARD_PAYMENT_FAILURE} ${responseData?.api_url}`))
            })
        }).catch((err) => {
            setIsPaymentLoading(false)
            setPage(2)
            setResponse(err)
            let errObject = {
                payload: request,
                errorMessage: err,
            }
            dispatch(addEventLog(errObject, `${CONSTANTS?.POST_CARD_PAYMENT_FAILURE} ${responseData?.api_url}`))
            setErrorMessage(err ? err : errorMessage?.somethingWentWrong)
        })
    }

    
    return (
        displayError ? <div className='main'>
            <div>
                <NoData message={failedMessage}/>
            </div>
        </div> : 
        <div className='main'>
                { page == 0 ?
                ispaymentLoading ? 
                    <div className='container'>
                        <div className=' d-flex justify-content-center p-2 border-grey border border-2 border-primary border-opacity-50 rounded'>
                        <p className='mb-0'>Please wait...</p> <span className='ms-2'><Circles
                                height="20"
                                width="20"
                                color='text-primary'
                                style={{ display: 'inline-block' }}
                                ariaLabel="circles-loading"
                                visible={true}
                            />
                            </span>
                        </div>
                    </div>
                    :
                    <div className='px-2 payButton'>
                        <GooglePayButton
                            buttonColor='default'
                            buttonType='buy'
                            environment={data?.heartland_payment_env?.toUpperCase() != 'TEST' ? 'PRODUCTION' : 'TEST'}
                            // environment={'TEST'}
                            paymentRequest={{
                                apiVersion: 2,
                                apiVersionMinor: 0,
                                allowedPaymentMethods: [
                                    {
                                        type: 'CARD',
                                        parameters: {
                                            allowedAuthMethods: ['PAN_ONLY', 'CRYPTOGRAM_3DS'],
                                            allowedCardNetworks: ['AMEX', 'DISCOVER', 'INTERAC', 'JCB', 'MASTERCARD', 'VISA'],
                                        },
                                        tokenizationSpecification: {
                                            type: 'PAYMENT_GATEWAY',
                                            parameters: {
                                                gateway: 'globalpayments',
                                                gatewayMerchantId: data?.heartland_merchant_id || '777704037403',
                                                // gatewayMerchantId: '777704037403',
                                            },
                                        },
                                    },
                                ],
                                merchantInfo: {
                                    merchantId: data?.heartland_mid || '650777704037403',
                                    merchantName: data?.heartland_merchant_name || 'Parkengage',
                                    // merchantId: '650777704037403',
                                    // merchantName: 'Parkengage',
                                },
                                transactionInfo: {
                                    totalPriceStatus: 'FINAL',
                                    totalPriceLabel: 'Total',
                                    totalPrice: JSON.parse(data?.request || '{}')?.total ? Number(JSON.parse(data?.request || '{}')?.total).toFixed(2) : 0,
                                    currencyCode: 'USD',
                                    countryCode: 'US',
                                },
                            }}
                            onLoadPaymentData={paymentDataResponse}
                        />
                    </div>
                : null}
        </div>
    )
}
mobileGooglePayHL.propTypes = {
    dispatch: PropTypes.func,
    faciltyData: PropTypes.object, 
    getValues: PropTypes.func, 
    onSubmit: PropTypes.func,
    setIsSubmittingForm: PropTypes.func,
    setThankYouMessage: PropTypes.func, 
    setResponse: PropTypes.func,
    setPage: PropTypes.func,
    page: PropTypes.number,
    setErrorMessage: PropTypes.func,
    setDisplayError: PropTypes.func,
    failedMessage: PropTypes.string,
    displayError: PropTypes.string,
}

mobileGooglePayHL.defaulProps = {
    dispatch: noop,
    faciltyData: EMPTY_OBJECT,
    getValues: noop, 
    onSubmit: noop,
    setIsSubmittingForm: noop,
    setThankYouMessage: noop, 
    setResponse: noop,
    setPage: noop,
    page: 0,
    setErrorMessage: noop,
    setDisplayError: noop,
    failedMessage: undefined,
    displayError: undefined,
}

function mapStateToProps() {
    return {
    }
}

export default connect(mapStateToProps)(mobileGooglePayHL)